import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import { Logger } from '../../ui-toolkit/logging/LoggerService';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { ExternalUrlFactory } from '../../ui-toolkit/rest/ExternalUrlFactory';

export const getPolicyNumberAsync = async (orderId: string, policyType: PolicyTypeEnum): Promise<string | null> => {
  try {
    const api = APIFactory(baseUrlService.ApiLocation);
    const response = await api(`/orders/american_digital/${orderId}`);
    if (response.data.policies && response.data.policies[getAmericanDigitalPolicyType(policyType)]) {
      return response.data.policies[getAmericanDigitalPolicyType(policyType)].id;
    } else {
      return null;
    }
  } catch (error: any) {
    Logger.error('Error in RestAmericanDigitalService.get', { error, orderId });
    return Promise.reject(
      `American Digital has not processed this order yet, policy cannot be generated. Please go to ${ExternalUrlFactory().urlFor.spruceHelpLinkUrl()} to submit a request for help.`
    );
  }
};

const getAmericanDigitalPolicyType = (policyType: PolicyTypeEnum): 'owner' | 'lender' =>
  policyType === PolicyTypeEnum.owner ? 'owner' : 'lender';
